import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import RankingSection from './components/RankingSection';

export default function Home() {
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫漫画网站 - 海量正版漫画在线阅读平台',
    description: '韩漫漫画网站作为海量正版漫画的在线阅读平台，提供免费的韩国漫画大全，确保您的每次阅读都建立在正规资源之上。',
    url: 'https://www.manhwa-reader.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫漫画网站',
      url: 'https://www.manhwa-reader.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <HotRecommend />
        <LatestUpdate />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}